import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import userinfo from 'store/modules/userinfo' ////用户信息仓库
import publicinfo from 'store/modules/publicinfo'
import regionnavigation from './modules/regionnavigation'
import configinfo from 'store/modules/configinfo'

export default new Vuex.Store({
  state: {
    ////用户的公共变量仓库  ///使用 this.$store.state.userinfo(子模组，没有时不写).userId（用户变量）
    token: sessionStorage.getItem('token') || ''
  },
  mutations: {
    ///同步提交信息的方法，组件中的使用 this.$store.commit('updataUserId（定义的方法名）' , '传入的参数')
    updataToken(state, token) {
      state.token = token
    }
  },
  actions: {
    ////使用方法：this.$store.dispatch('asyUpdataUserId',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
    asyUpdataToken(context, token) {
      context.commit('updataToken', token)
    }
  },
  getters: {
    //获取token方法
    // 只读取凭证，避免 getter 修改状态或把未登录状态变成 null。
    getToken(state) {
      return state.token || sessionStorage.getItem('token') || ''
    }
  },
  modules: {
    ////子模组
    regionnavigation,
    userinfo,
    publicinfo,
    configinfo
  }
})

// import store from 'store/index'  ///导入公共仓库
